'use client'
import { Suspense } from 'react'
import CreateDetails from './CreateDetails'

export default function Create() {
  return (
    <main className="mt-4 w-full pl-2 pr-5">
      <Suspense>
        <CreateDetails />
      </Suspense>
    </main>
  )
}
